import { get } from "lodash-es";
import { call, put, takeLatest } from "redux-saga/effects";
import { fetch_fund_details, fetch_fund_graph } from "../../apis/fundDetails";
import { fetchFundDetails, fetchFundGraphData, setFundDetails, setFundGraphData } from "../reducers/fundDetails";
import { setError } from "../reducers/error";
import { setLoader } from "../reducers/loader";
import { ErrorMessages } from "../../constants/fundDetails";
import { genericErrorMessage } from "../../apis/common";

const {isinError, fundNotAvailable} = ErrorMessages;

export default function* sagaFetchFundDetails() {
  yield takeLatest(fetchFundDetails.toString(), handleFetchFundDetails);
  yield takeLatest(fetchFundGraphData.toString(), handleFetchFundGraphData);
}

function* handleFetchFundDetails({ payload }) {
  const { Api, isins, screen, token } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const fundData = yield call(fetch_fund_details, Api, isins, token);
    const textReport = get(fundData, "text_report[0]", {});
    const errorMsg = get(textReport, 'error');
    if(errorMsg) {
      if(errorMsg === isinError) {
        yield put(setError({ screen, isFetchFailed: true, message: fundNotAvailable }));
      } else {
        yield put(setError({ screen, isFetchFailed: true, message: genericErrorMessage }));
      }
    } else {
      yield put(setFundDetails(textReport));
    }
  } catch (err) {
    console.log("error is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchFundGraphData({ payload }) {
  const { Api, isin, screen, token } = payload;
  try {
    yield put(setLoader({ screen, isGraphLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: "",
      })
    );
    const fundGraphData = yield call(fetch_fund_graph, Api, isin, token);
    yield put(setFundGraphData(fundGraphData));
  } catch (err) {
    console.log("error is", err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isGraphLoading: false }));
  }
}
